import Vue from 'vue'
import Router from 'vue-router'
import Signup from './views/Signup.vue'
import Signin from './views/Signin.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { authOnly: true, title: 'YetVPN Home'},
      component: () => import('./views/Home.vue')
    },
    {
      path: '/signup',
      name: 'signup',
      meta: { authOnly: false, title: 'YetVPN SignUp'},
      component: Signup
    },
    {
      path: '/signin',
      name: 'signin',
      meta: { authOnly: false, title: 'YetVPN SignIn'},
      component: Signin
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authOnly) && !store.getters.getAuthState) {
    next({ path: '/signin', query: { redirect: to.fullPath }});
  } else {
    next();
  }
});

router.afterEach( (to, from) => {
  document.title = to.meta.title;
});

export default router;